import { TarifiedItem } from "./tarified-item.model";

export interface TarificationSessionKeyType {
  tarificationSessionId: string;
  edit: boolean;
  errors: string[];
  warnings: string[];
  totalPaid: number;
  totalPatientContribution: number;
  totalReimbursed: number;
  totalValue: number;
  tarifiedItems: TarifiedItem[];
}

export class TarificationSessionKey implements TarificationSessionKeyType {
  tarificationSessionId: string;
  edit: boolean;
  errors: string[];
  warnings: string[];
  totalPaid: number;
  totalPatientContribution: number;
  totalReimbursed: number;
  totalValue: number;
  tarifiedItems: TarifiedItem[];

  constructor(data?: TarificationSessionKeyType) {
    this.tarificationSessionId = "";
    this.edit = false;
    this.errors = [];
    this.warnings = [];
    this.totalPaid = 0;
    this.totalPatientContribution = 0;
    this.totalReimbursed = 0;
    this.totalValue = 0;
    this.tarifiedItems = [];
    data && Object.assign(this, data);
    data &&
      Object.assign(
        this.tarifiedItems,
        data.tarifiedItems.map(it => new TarifiedItem(it))
      );
  }
}
